import { render, staticRenderFns } from "./company-type.form.vue?vue&type=template&id=6e1adcf0&"
import script from "./company-type.form.vue?vue&type=script&lang=js&"
export * from "./company-type.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports